var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V24H36V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 8H0V16H36V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 16H0V24H36V16Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.2C19.7673 15.2 21.2 13.7673 21.2 12C21.2 10.2327 19.7673 8.79999 18 8.79999C16.2327 8.79999 14.8 10.2327 14.8 12C14.8 13.7673 16.2327 15.2 18 15.2Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.8C19.5464 14.8 20.8 13.5464 20.8 12C20.8 10.4536 19.5464 9.20001 18 9.20001C16.4536 9.20001 15.2 10.4536 15.2 12C15.2 13.5464 16.4536 14.8 18 14.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.56C18.3093 12.56 18.56 12.3093 18.56 12C18.56 11.6907 18.3093 11.44 18 11.44C17.6907 11.44 17.44 11.6907 17.44 12C17.44 12.3093 17.6907 12.56 18 12.56Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7578 12.5043C20.8344 12.5144 20.9048 12.4604 20.9148 12.3838C20.9249 12.3071 20.871 12.2368 20.7943 12.2267C20.7177 12.2166 20.6473 12.2706 20.6372 12.3472C20.6272 12.4239 20.6811 12.4942 20.7578 12.5043Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.8001L18.096 13.1201L18 12.3201L17.904 13.1201L18 14.8001Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5333 13.2009C20.6047 13.2305 20.6866 13.1966 20.7162 13.1252C20.7458 13.0537 20.7119 12.9718 20.6404 12.9422C20.569 12.9127 20.4871 12.9466 20.4575 13.018C20.4279 13.0894 20.4618 13.1713 20.5333 13.2009Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2753 14.7046L17.8028 13.1067L17.9172 12.3091L17.6174 13.057L17.2753 14.7046Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1361 13.8156C20.1975 13.8627 20.2854 13.8511 20.3324 13.7898C20.3795 13.7284 20.3679 13.6405 20.3066 13.5935C20.2453 13.5464 20.1574 13.558 20.1103 13.6193C20.0632 13.6807 20.0748 13.7685 20.1361 13.8156Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 14.4249L17.5231 13.018L17.84 12.2772L17.3568 12.922L16.6 14.4249Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5935 14.3067C19.6405 14.368 19.7284 14.3796 19.7898 14.3325C19.8511 14.2854 19.8627 14.1976 19.8156 14.1362C19.7685 14.0749 19.6806 14.0633 19.6193 14.1104C19.558 14.1574 19.5464 14.2453 19.5935 14.3067Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0201 13.98L17.2759 12.8599L17.7737 12.2263L17.1402 12.7241L16.0201 13.98Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9422 14.6404C18.9718 14.7119 19.0537 14.7458 19.1251 14.7162C19.1965 14.6866 19.2304 14.6047 19.2009 14.5333C19.1713 14.4618 19.0894 14.4279 19.0179 14.4575C18.9465 14.4871 18.9126 14.569 18.9422 14.6404Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5751 13.4L17.078 12.6431L17.7229 12.16L16.982 12.4768L15.5751 13.4Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2267 14.7943C18.2368 14.871 18.3071 14.9249 18.3838 14.9148C18.4604 14.9047 18.5144 14.8344 18.5043 14.7578C18.4942 14.6811 18.4239 14.6271 18.3472 14.6372C18.2706 14.6473 18.2166 14.7176 18.2267 14.7943Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2954 12.7247L16.943 12.3826L17.6909 12.0828L16.8933 12.1971L15.2954 12.7247Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4957 14.7578C17.4856 14.8345 17.5396 14.9048 17.6162 14.9149C17.6929 14.925 17.7632 14.871 17.7733 14.7944C17.7834 14.7177 17.7295 14.6474 17.6528 14.6373C17.5761 14.6272 17.5058 14.6812 17.4957 14.7578Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 12.0001L16.88 12.0961L17.68 12.0001L16.88 11.9041L15.2 12.0001Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7991 14.5334C16.7695 14.6048 16.8035 14.6867 16.8749 14.7163C16.9463 14.7459 17.0282 14.7119 17.0578 14.6405C17.0874 14.5691 17.0535 14.4872 16.982 14.4576C16.9106 14.428 16.8287 14.4619 16.7991 14.5334Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2954 11.2754L16.8933 11.8029L17.6909 11.9173L16.943 11.6175L15.2954 11.2754Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1844 14.1362C16.1373 14.1976 16.1489 14.2855 16.2102 14.3325C16.2716 14.3796 16.3595 14.368 16.4065 14.3067C16.4536 14.2453 16.442 14.1575 16.3807 14.1104C16.3193 14.0633 16.2315 14.0749 16.1844 14.1362Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5751 10.6001L16.9821 11.5232L17.7229 11.8401L17.0781 11.357L15.5751 10.6001Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6934 13.5935C15.632 13.6406 15.6204 13.7284 15.6675 13.7898C15.7146 13.8511 15.8025 13.8627 15.8638 13.8156C15.9252 13.7686 15.9367 13.6807 15.8897 13.6193C15.8426 13.558 15.7547 13.5464 15.6934 13.5935Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0201 10.0201L17.1401 11.276L17.7737 11.7738L17.2759 11.1402L16.0201 10.0201Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3596 12.9422C15.2881 12.9718 15.2542 13.0537 15.2838 13.1251C15.3134 13.1966 15.3953 13.2305 15.4667 13.2009C15.5382 13.1713 15.5721 13.0894 15.5425 13.018C15.5129 12.9466 15.431 12.9126 15.3596 12.9422Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 9.57518L17.3568 11.0781L17.84 11.7229L17.5231 10.9821L16.6 9.57518Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2057 12.2268C15.129 12.2368 15.075 12.3072 15.0851 12.3838C15.0952 12.4605 15.1656 12.5144 15.2422 12.5044C15.3189 12.4943 15.3728 12.4239 15.3627 12.3473C15.3526 12.2706 15.2823 12.2167 15.2057 12.2268Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2753 9.29549L17.6174 10.9431L17.9172 11.691L17.8028 10.8934L17.2753 9.29549Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2422 11.4957C15.1656 11.4857 15.0952 11.5396 15.0852 11.6163C15.0751 11.6929 15.129 11.7633 15.2057 11.7734C15.2823 11.7834 15.3527 11.7295 15.3628 11.6528C15.3728 11.5762 15.3189 11.5058 15.2422 11.4957Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.20005L17.904 10.8801L18 11.6801L18.096 10.8801L18 9.20005Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4667 10.7991C15.3953 10.7695 15.3134 10.8035 15.2838 10.8749C15.2542 10.9463 15.2881 11.0282 15.3596 11.0578C15.431 11.0874 15.5129 11.0535 15.5425 10.982C15.5721 10.9106 15.5382 10.8287 15.4667 10.7991Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7247 9.29542L18.1972 10.8933L18.0828 11.6909L18.3826 10.943L18.7247 9.29542Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8639 10.1845C15.8025 10.1374 15.7146 10.149 15.6676 10.2103C15.6205 10.2716 15.6321 10.3595 15.6934 10.4066C15.7547 10.4537 15.8426 10.4421 15.8897 10.3808C15.9368 10.3194 15.9252 10.2315 15.8639 10.1845Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 9.57513L18.4769 10.9821L18.16 11.7229L18.6432 11.0781L19.4 9.57513Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4065 9.69339C16.3595 9.63205 16.2716 9.62048 16.2102 9.66755C16.1489 9.71462 16.1373 9.8025 16.1844 9.86385C16.2315 9.92519 16.3194 9.93676 16.3807 9.88969C16.442 9.84262 16.4536 9.75473 16.4065 9.69339Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9799 10.0201L18.7241 11.1402L18.2263 11.7737L18.8598 11.2759L19.9799 10.0201Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0578 9.35957C17.0282 9.28814 16.9463 9.25422 16.8749 9.28381C16.8035 9.3134 16.7696 9.39529 16.7991 9.46673C16.8287 9.53816 16.9106 9.57208 16.9821 9.54249C17.0535 9.5129 17.0874 9.43101 17.0578 9.35957Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4249 10.6L18.922 11.3569L18.2771 11.84L19.018 11.5232L20.4249 10.6Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7733 9.20569C17.7632 9.12903 17.6929 9.07507 17.6162 9.08516C17.5396 9.09526 17.4856 9.16558 17.4957 9.24224C17.5058 9.3189 17.5761 9.37286 17.6528 9.36277C17.7294 9.35268 17.7834 9.28235 17.7733 9.20569Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7046 11.2753L19.057 11.6174L18.3091 11.9172L19.1067 11.8029L20.7046 11.2753Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5043 9.24217C18.5144 9.16551 18.4604 9.09518 18.3838 9.08509C18.3071 9.075 18.2368 9.12896 18.2267 9.20562C18.2166 9.28228 18.2705 9.3526 18.3472 9.3627C18.4239 9.37279 18.4942 9.31882 18.5043 9.24217Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 11.9999L19.12 11.9039L18.32 11.9999L19.12 12.0959L20.8 11.9999Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2009 9.46664C19.2305 9.3952 19.1965 9.31331 19.1251 9.28372C19.0537 9.25413 18.9718 9.28805 18.9422 9.35949C18.9126 9.43092 18.9465 9.51282 19.018 9.54241C19.0894 9.572 19.1713 9.53807 19.2009 9.46664Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7046 12.7246L19.1067 12.1971L18.3091 12.0827L19.057 12.3825L20.7046 12.7246Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8156 9.86377C19.8627 9.80242 19.8511 9.71454 19.7898 9.66747C19.7284 9.6204 19.6405 9.63197 19.5935 9.69331C19.5464 9.75465 19.558 9.84254 19.6193 9.88961C19.6807 9.93668 19.7685 9.92511 19.8156 9.86377Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4249 13.3999L19.0179 12.4768L18.2771 12.1599L18.9219 12.643L20.4249 13.3999Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 10.4065C20.368 10.3594 20.3796 10.2716 20.3325 10.2102C20.2854 10.1489 20.1975 10.1373 20.1362 10.1844C20.0748 10.2314 20.0633 10.3193 20.1103 10.3807C20.1574 10.442 20.2453 10.4536 20.3066 10.4065Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9799 13.9799L18.8599 12.724L18.2263 12.2262L18.7241 12.8598L19.9799 13.9799Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6404 11.0578C20.7119 11.0282 20.7458 10.9463 20.7162 10.8749C20.6866 10.8034 20.6047 10.7695 20.5333 10.7991C20.4618 10.8287 20.4279 10.9106 20.4575 10.982C20.4871 11.0534 20.569 11.0874 20.6404 11.0578Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 14.4248L18.6432 12.9219L18.16 12.2771L18.4769 13.0179L19.4 14.4248Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7943 11.7732C20.871 11.7632 20.925 11.6928 20.9149 11.6162C20.9048 11.5395 20.8344 11.4856 20.7578 11.4956C20.6811 11.5057 20.6272 11.5761 20.6373 11.6527C20.6474 11.7294 20.7177 11.7833 20.7943 11.7732Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7247 14.7045L18.3826 13.0569L18.0828 12.309L18.1971 13.1066L18.7247 14.7045Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.2a80d76483d801af8b6130011a793e2f.svg";
export { ForwardRef as ReactComponent };